export default "__VITE_ASSET__92e82e63__"